import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=9c35eee4&scoped=true"
import script from "./card-detail.vue?vue&type=script&lang=js"
export * from "./card-detail.vue?vue&type=script&lang=js"
import style0 from "./card-detail.vue?vue&type=style&index=0&id=9c35eee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c35eee4",
  null
  
)

export default component.exports